export default "__VITE_ASSET__DJCXkl66__"